import { useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */
function getCroppedImg(image, crop, fileName) {
  if (!image) return;

  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height,
  );

  // As Base64 string
  // const base64Image = canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) return;

      blob.name = fileName;
      resolve(blob);
    }, 'image/png', 1);
  });
}

const ImageCropper = ({ aspect = 1, src, isOpen, onComplete, setIsOpen }) => {
  const [image, setImage] = useState();
  // const height = 300;
  // const width = height * aspect;

  const [crop, setCrop] = useState({
    aspect, // 16 / 16
    x: 0,
    y: 0,
  });

  const onCropComplete = (croppedArea, _croppedAreaPixels) => {
    setCrop(croppedArea);
  }

  const handleClose = () => {
    getCroppedImg(image, crop, 'avatar.png').then(onComplete);
    setIsOpen(false);
  }

  if (!isOpen) return null;

  return (
    <div className={`modal ${isOpen ? 'is-active' : ''}`}>
      <div className="modal-background"></div>
      <div className="modal-content has-text-centered">
        <ReactCrop
          src={src}
          crop={crop}
          className='checkered'
          minWidth={150}
          maxWidth={640}
          keepSelection={true}
          onImageLoaded={image => {
            image.crossOrigin = "anonymous";

            let minHeight = Math.min(crop.height || Number.MAX_SAFE_INTEGER, image.height);
            let minWidth = Math.min(crop.width || Number.MAX_SAFE_INTEGER, image.width);

            setImage(image);

            if (minHeight * aspect <= image.width) {
              setCrop({
                ...crop,
                width: minHeight * aspect,
                height: minHeight
              });

              return false;
            }

            if (minWidth / aspect <= image.height) {
              setCrop({
                ...crop,
                width: minWidth,
                height: minWidth / aspect
              });

              return false;
            }

            setCrop({
              ...crop,
              width: image.width,
              height: image.height
            });

            return false;
          }}
          onChange={setCrop}
          onComplete={(crop, percentCrop) => {
            onCropComplete(crop, percentCrop);
          }}
        />
      </div>
      <button type="button" className="modal-close is-large" aria-label="close" onClick={handleClose}></button>
    </div>
  );
}

export default ImageCropper;
